"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PlusCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-414.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(415.000000, 345.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(-1.000000, -1.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fill: color,
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M12.4,10.6 L17,10.6 C17.4970563,10.6 17.9,11.0029437 17.9,11.5 C17.9,11.9588212 17.5566633,12.3374518 17.1128941,12.3929877 L17,12.4 L12.4,12.4 L12.4,17 C12.4,17.4970563 11.9970563,17.9 11.5,17.9 C11.0411788,17.9 10.6625482,17.5566633 10.6070123,17.1128941 L10.6,17 L10.6,12.4 L6,12.4 C5.50294373,12.4 5.1,11.9970563 5.1,11.5 C5.1,11.0411788 5.44333667,10.6625482 5.88710591,10.6070123 L6,10.6 L10.6,10.6 L10.6,6 C10.6,5.50294373 11.0029437,5.1 11.5,5.1 C11.9588212,5.1 12.3374518,5.44333667 12.3929877,5.88710591 L12.4,6 L12.4,10.6 Z M11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 Z M11.5,2 C6.25329488,2 2,6.25329488 2,11.5 C2,16.7467051 6.25329488,21 11.5,21 C16.7467051,21 21,16.7467051 21,11.5 C21,6.25329488 16.7467051,2 11.5,2 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(5.000000, 5.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(6.500000, 6.500000) rotate(-315.000000) translate(-6.500000, -6.500000) translate(2.000000, 2.000000)"
                })
              })
            })
          })]
        })
      })
    })
  })]
});

PlusCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = PlusCircleIcon;
exports.default = _default;